export default "__VITE_ASSET__CL8S8FA9__"